export const NsInputterValidations = {
  isRequired: 'isRequired',
  isNumber: 'isNumber',
  isInteger: 'isInteger',
  isFirstName: 'isFirstName',
  isLastName: 'isLastName',
  isFullName: 'isFullName',
  isTitle: 'isTitle',
  isEmail: 'isEmail',
  isMobileNumber: 'isMobileNumber',
  isPassword: 'isPassword',
  isDateOfBirth: 'isDateOfBirth',
  isPostcode: (includeIreland) => `isPostcode(${includeIreland})`,
  isPhoneNumber: (includeIreland) => `isPhoneNumber(${includeIreland})`,
  minLength: (value) => `minLength(${value})`,
  maxLength: (value) => `maxLength(${value})`,
  isBetween: (min, max) => `isBetween(${min},${max})`
};
